import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-export",
  "use": "icon-export-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-export\"><path d=\"M606.71 838.93a4.87 4.87 0 0 1-4.92 4.92H173a4.87 4.87 0 0 1-4.92-4.92V172.25a4.87 4.87 0 0 1 4.92-4.92h428.79a4.87 4.87 0 0 1 4.92 4.92v102.89h60.52V172.25a65.51 65.51 0 0 0-65.44-65.44H173a65.51 65.51 0 0 0-65.44 65.44v666.68A65.51 65.51 0 0 0 173 904.37h428.79a65.51 65.51 0 0 0 65.44-65.44V714.1h-60.52z\" p-id=\"4088\" /><path d=\"M712.04 294.25l-40.07 45.37 153.78 135.8H438.76v60.53h379.32L673.33 649.44l37.35 47.63 242.32-190-240.96-212.82z\" p-id=\"4089\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/export.svg
// module id = gmuv
// module chunks = 42